import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  ShowButton,
  ChipField,
  Filter,
  TextInput,
  ReferenceArrayInput,
  SelectArrayInput
} from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from '../Actions'

const AreainfoFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <TextInput source="name_contains" />
      <ReferenceArrayInput
        alwaysOn
        style={{ minWidth: "200px" }}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};

export const AreainfoList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      title="areainfo.areainfo"
      bulkActions={false}
      actions={<Actions create />}
      filters={<AreainfoFilter />}
      filterDefaultValues={filter}
    >
      <Datagrid>
        <div />
        <TextField source="name" />
        <ReferenceField linkType={false} source="project" reference="project">
          <ChipField source="name" />
        </ReferenceField>
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/areainfo/AreainfoList.js